import React from "react";
import axios from "axios";
import { Feature } from "../models/api";
import { ApiResponse } from "./auth";
import { BASE_URL } from "constants/api";
import { IDropDown, IUser } from "models/user";


export async function fetchServices() {
  const url =
    window.location.protocol + "//" + window.location.host + "/features.json";
  const response = await axios.get<Feature[]>(url);

  return response.data;
}

export async function getDropDown(params: string = "") : Promise<ApiResponse<IDropDown>> {
  const response = await axios.get(BASE_URL + "api/Masterlist" + params);
  return response.data;
}